import { render, staticRenderFns } from "./WaitListBtn.vue?vue&type=template&id=33f785fc&scoped=true&"
import script from "./WaitListBtn.vue?vue&type=script&lang=js&"
export * from "./WaitListBtn.vue?vue&type=script&lang=js&"
import style0 from "./WaitListBtn.vue?vue&type=style&index=0&id=33f785fc&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f785fc",
  null
  
)

export default component.exports